import FooterNavLink from "../components/FooterNavLink";

const NAV_LINKS = [
  { href: "#features", label: "Features", external: false },
  { href: "#why-us", label: "Why Us?", external: false },
  // { href: "#pricing", label: "Pricing", external: false }, // hidden until launch
  { href: "#team", label: "Team", external: false },
  { href: "#faqs", label: "FAQ's", external: false },
  { href: "/privacy", label: "Privacy Policy", external: true },
  { href: "/terms", label: "Terms & Conditions", external: true },
];

export default function FooterSection() {
  return (
    <footer id="footer" className="scroll-mt-24 bg-black text-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24">
        <div className="flex flex-col gap-10 sm:flex-row sm:items-start sm:justify-between sm:gap-8">
          <div className="flex items-center">
            <img
              src="/images/landing-v2/footer/shadowlabs-logo.svg"
              alt="ShadowLabs"
              className="h-10 w-auto select-none sm:h-12"
              draggable="false"
            />
          </div>
          <div className="sm:text-right">
            <p className="text-sm font-medium text-white">Navigation</p>
            <nav className="mt-5 grid grid-cols-1 gap-3">
              {NAV_LINKS.map((link) => (
                <FooterNavLink key={link.href} href={link.href} external={link.external}>
                  {link.label}
                </FooterNavLink>
              ))}
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}
